import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

import EditCertificate from 'views/certificates/edit';
import GuestLayout from 'layout/GuestLayout';
import ViewCertificate from 'views/certificates/view';
import ViewSummaryCertificate from 'views/certificates/summary-view';
import ViewCertificateSummary from 'views/certificates/summary-view';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/auth/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/auth/ForgotPassword')));
const AuthCodeVerification = Loadable(lazy(() => import('views/pages/authentication/auth/CodeVerification')));
const DashboardAnalytics = Loadable(lazy(() => import('views/dashboard/Analytics')));
// ==============================|| AUTH ROUTING ||============================== //

const GuestRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/certificate',
            element: <ViewCertificate />
        },
        {
            path: '/certificates/:id/summary',
            element: <ViewCertificateSummary />
        }
    ]
};

export default GuestRoutes;
